(function () {
  'use strict';
  angular.module('claims')
    .component('claimsGrid', {
        bindings: {
          promise: '<',
          isRunning: '=',
          serviceUnavailable: '='
        },
        controller: ['$state', '$filter', 'gridServices', 'uiGridConstants', '$scope', function claimsGridController($state, $filter, gridServices, uiGridConstants, $scope) {
          var ctrl = this;
          ctrl.claimsServiceUnavailable = false;
          var dateSort = _.curry(function (aDate, bDate) {
              var a=new Date(aDate);
              var b=new Date(bDate);
              if (a < b) {
                return -1;
              }
              else if (a > b) {
                return 1;
              }
              else {
                return 0;
              }
          });
          ctrl.gridOptions = {
            enableSorting: true,
            enableColumnResizing: true,
            enableRowHeaderSelection: false,
            exporterMenuPdf: false,
            enableGridMenu: true,
            columnDefs: [
              { field: 'payer', displayName: 'Payer Name', width: 200},
              { field: 'claimNumber', displayName: 'Claim Number', width: 140, cellTemplate:
            	  '<div ng-show=\"row.entity.claimStatus != \'Pending\'\" class="ui-grid-cell-contents">' +
                  '<a ui-sref = "claimLines({claimId: row.entity.claimId})">{{row.entity.claimNumber}}</a>' + '</div>' +
                  '<div ng-show=\"row.entity.claimStatus == \'Pending\'\" class="ui-grid-cell-contents">' +
                  '{{row.entity.claimNumber}}' + '</div>'
              },
              { field: 'dateReceived()', displayName: 'Date Received', width: 110,
                  sortingAlgorithm:  dateSort()
              },
              { field: 'claimStatus', displayName: 'Status', width: 80 },
              { field: 'dateProcessed()', displayName: 'Date Processed', width: 120,
            	  sortingAlgorithm: dateSort()
              },
              { field: 'renderingProvider', displayName: 'Rendering Provider', width: 130 },
              { field: 'patientName', displayName: 'Patient Name', width: 100 , cellTemplate: '<div ng-show=\"row.entity.referenceId.toString().length > 0\" class="ui-grid-cell-contents">' +
                   '  <a ui-sref="benefits.dashboard({referenceId:' + "'{{row.entity.referenceId}}'" + ', dateOfBirth:' +"'{{row.entity.dateOfBirth}}'" + ', subscriberId:' +"'{{row.entity.subscriberId}}'" + '})">{{row.entity.patientName}}</a>' +  '</div>' +
                   '<div ng-show="!row.entity.referenceId.value" class="ui-grid-cell-contents">' +
                   '{{row.entity.patientName}}' + '</div>'
              },

              { field: 'dtOfBirth()', displayName: 'DOB', width: 90,
            	  sortingAlgorithm: dateSort()
              },
              { field: 'subscriberId', displayName: 'Subscriber ID', width: 110 },
              { field: 'dateOfService()', displayName: 'DOS', width: 90,
            	  sortingAlgorithm: dateSort()
              },
              { field: 'billedAmount()', displayName: 'Billed Amount', width: 130, type: 'numberStr'},
              { field: 'paidAmount()', displayName: 'Paid Amount', width: 130, type: 'numberStr' },
              { field: 'memberResponsibility()', displayName: 'Member Responsibility', width: 130, type: 'numberStr' },
              { field: 'network', displayName: 'Network Fee Schedule', width: 110  },
              { field: 'payee', displayName: 'Payee', width: 110 }
            ],
            onRegisterApi: function(api) {
              ctrl.gridApi = api;
            }
          };
          this.$onInit = function () {
            $scope.$watch('$ctrl.gridRunning', function(val) {
              ctrl.isRunning = val;
              ctrl.serviceUnavailable = ctrl.claimsServiceUnavailable;
            });
          };
          function getClaimsResult() {
            ctrl.gridOptions.data = [];
            if (ctrl.promise) {
              ctrl.gridRunning = true;
              ctrl.promise.then(function(response) {
              ctrl.gridRunning = false;
              ctrl.claimsServiceUnavailable = response.serviceUnavailable;
              if(response.data){
                if(response.data.claims.length > 99){
                    ctrl.resultsExceded = true;
                }
            	_.each(response.data.claims, (row) => {
            	  var pAmt = row.paidAmount;
                  row.paidAmount =  function() {
                    return $filter('currency')(pAmt);
                  };
                  var bAmt = row.billedAmount;
                  row.billedAmount =  function() {
                      return $filter('currency')(bAmt);
                  };
                  var mAmt = row.memberResponsibility;
                  row.memberResponsibility =  function() {
                      return $filter('currency')(mAmt);
                  };
                  var rDate = row.receivedDate;
                  row.dateReceived =  function() {
                      return $filter('portalDate')(rDate);
                  };
                  var pDate = row.dateProcessed;
                  row.dateProcessed =  function() {
                      return $filter('portalDate')(pDate);
                  };
                  var bDate = row.dateOfBirth;
                  row.dtOfBirth =  function() {
                      return $filter('portalDate')(bDate);
                  };
                  var sDate = row.dateOfService;
                  row.dateOfService =  function() {
                      return $filter('portalDate')(sDate);
                  };
                });
                ctrl.gridOptions.data = response.data.claims;
              } else {
                ctrl.gridOptions.data = [];
              }

              }, function(rejection) {
                ctrl.gridRunning = false;
              });
            }
          }

          this.$onChanges = function (changes) {
            this.promise = changes.promise.currentValue;
            getClaimsResult();
          };
        }],
        templateUrl: '/js/claims/claimsGrid.html' + appVersion
      }
    );
})();
